import { useMemo } from "react";
import type { ImmutableObject } from "@/lib/immutable";
import { createStore, type Store, useStore } from "./store";

export class LocaleModel {
	language: string = "";
	// country: string = '';
}

export type TranslationCaptions = {
	en?: string | null;
	es?: string | null;
	fr?: string | null;
};

const storefront_locale_key = "storefront-locale";
let initialState = new LocaleModel();
const localstorageJson = window.localStorage.getItem(storefront_locale_key);
if (localstorageJson) {
	try {
		initialState = JSON.parse(localstorageJson);
	} catch (ex) {
		console.error(ex);
	}
} else {
	const [language /*, country*/] = window.navigator.language.split("-");
	initialState = {
		language: language,
		//country: country
	};
	window.localStorage.setItem(
		storefront_locale_key,
		JSON.stringify(initialState),
	);
}
const localeGlobalStore = createStore<LocaleModel>(initialState);

export class LocaleState {
	private localeState: Store<LocaleModel>;

	constructor(localeState: Store<LocaleModel>) {
		this.localeState = localeState;
	}

	get(): ImmutableObject<LocaleModel> {
		return this.localeState.getState();
	}

	private saveToLocalStorage() {
		const obj = this.localeState.getState();
		let json = "";
		if (obj) {
			json = JSON.stringify(obj);
		}
		window.localStorage.setItem(storefront_locale_key, json);
	}

	setLanguage(language: string) {
		this.localeState.setState((prev) => ({ ...prev, language }));
		this.saveToLocalStorage();
	}

	getLanguageFriendlyName() {
		const language = this.localeState.getState().language;
		switch (language) {
			case "en":
				return "English";
			case "es":
				return "Español";
			case "fr":
				return "Français";
			default:
				return "?";
		}
	}

	translate(labels: TranslationCaptions): string {
		const language = this.localeState.getState().language as "en" | "es" | "fr";
		switch (language) {
			case "en":
			case "es":
			case "fr":
				return labels[language] || "";
			default:
				if (labels.en) return labels.en;
				return "";
		}
	}
}

export function useLocaleState(): LocaleState {
	useStore(localeGlobalStore);
	return useMemo(() => new LocaleState(localeGlobalStore), []);
}
